<template>
  <section>
    <div id="camera-player-control" v-on:click.stop>
      <div
        class="camera-player-controls"
        :style="videoControlStyle"
      >
        <div v-if="mode === 'history'" class="video-progress" >
          <vue-slider
            :value="offsetCurrent"
            :min="0"
            :max="3600"
            :marks="marksSeek"
            :hide-label="true"
            :tooltip="'active'"
            :use-keyboard="false"
            :tooltip-formatter="formatter"
            :process-style="{ backgroundColor: '#48A0F4' }"
            :tooltip-style="{
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              borderColor: 'rgba(0, 0, 0, 0.6)'
            }"
            :duration="0"
            @change="onChangeSeek($event)"
          >
            <template v-slot:dot="{ focus }">
              <div :class="['play-back-video-seek-dot', { focus }]"></div>
            </template>
          </vue-slider>
          <div class="seek-tooltip" id="seek-tooltip">{{ currentTime }}</div>
        </div>

        <div class="bottom-controls">
          <div class="left-controls" v-if="mode === 'history'">

            <feather-icon
              v-if="!isPlay"
              id="play"
              class="play-button"
              @click="onPlay"
              icon="PlayIcon"
            />
            <feather-icon
              v-else
              id="pause"
              class="pause-button"
              @click="onPlay"
              icon="PauseIcon"
            />
            <div class="volume-controls">
              <feather-icon
                id="volume-button"
                :icon="volumeIcon"
                class="volume-button"
              />
              <input
                class="volume"
                id="volume"
                v-model="volume"
                data-mute="0.5"
                type="range"
                max="1"
                min="0"
                step="0.01"
                @change="onChangeVolume()"
              />
            </div>

          </div>
          <div class="right-controls ml-auto">
            <!-- 再生速度変更（historyモードのみ） -->
            <div v-if="mode === 'history'" class="relative mt-1 mr-8">
              <!-- 再生速度ドロップダウン -->
              <vs-dropdown
                vs-trigger-click
                class="cursor-pointer"
                id="playback-rate"
              >
                <div style="width: 3rem; font-size: larger;">{{ 'x' + fps }}</div>
                <vs-dropdown-menu id="playback-rate-menu" class="flex justify-start">
                  <vs-dropdown-item
                    v-for="(playbackRate, index) in playbackRateList"
                    :key="index"
                  >
                    <div
                      class="playback-rate-item flex items-center"
                      @click.prevent="setFpsValue(playbackRate)"
                      style="height: 1.4rem; padding: 0 1rem; margin: 0; border-radius: 0.6rem; color: white;"
                      :style="{
              'background-color': fps === playbackRate ? '#48a0f4' : null
            }"
                    >
            <span class="whitespace-no-wrap">{{
                playbackRate === 1 ? '(標準)' : 'x ' + playbackRate
              }}</span>
                    </div>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <!-- フルスクリーンは常に右端 -->
            <feather-icon
              id="fullscreen-button"
              @click="onChangeFullscreen"
              :icon="fullscreenIcon"
              class="cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- サムネイル作業領域 -->
    <div style="display: none; position: absolute; top: 0; left: 0; width: 800px; height: 450px;">
      <video-player
        v-if="mode === 'history'"
        id="hidden-video-player"
        class="media-video-player card-video vjs-big-play-centered"
        ref="hiddenVideoPlayer"
        :options="playerOptions"
        :style="{ 'min-width': '100%', 'min-height': '100%', }"
      />
    </div>

  </section>
</template>

<script>
import moment from "moment-timezone";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

import { videoPlayer } from "vue-videojs7";
import "vue-slider-component/theme/antd.css";

// Mixin
import { CameraMixin, ColorMixin } from "@/mixins";

export default {
  name: "PlayerControl",
  components: {
    VueSlider,
    videoPlayer,
  },
  mixins:[CameraMixin, ColorMixin],
  data() {
    return {
      isPlay: false,
      ended: false,
      isFullscreen: false,
      playbackRateList: [16, 8, 4, 2, 1],
      videoProgressValue: 0,
      videoProgressMax: 0,
      volume: 0,
      seek: 0,
      formatter: v => `${moment.unix(this.start + v).format("HH:mm:ss")}`,
      noImageUrl: require("@/assets/images/no_image.png"),
      processStyle: {
        borderColor: "rgba(0, 0, 0, 0.6)",
        backgroundColor: "rgba(0, 0, 0, 0.6)"
      },
      tooltipStyle: {
        borderColor: "rgba(0, 0, 0, 0.6)",
        backgroundColor: "rgba(0, 0, 0, 0.6)"
      },
      videoControlStyle: {
        right: 1,
        left: 1,
        bottom: 1,
        'background-color': 'black',
      },
      marksSeek: val => val % 300 === 0 ? ({
                      style: {
              width: '1px',
              height: '1px',
              display: 'block',
              borderRadius: '0',
              backgroundColor: '#626262',
              transform: 'translate(1px, 1.5px)'
            },
                    }) : false,
      thumbnails: [],
    };
  },
  props: {
    current: { type: Number, required: false },
    start:   { type: Number, required: false },
    mode:    { type: String, required: false },
    fps:     { type: Number, required: false, default: 1, },
  },
  computed: {
    reverse: function() {
      return {
        active: this.getReverse && !this.getPause
      };
    },
    play: function() {
      return {
        active: !this.getReverse && !this.getPause
      };
    },
    startTime() {
      return moment.unix(this.start).format("HH:mm:ss");
    },
    currentTime() {
      return moment.unix(this.current).format("HH:mm:ss");
    },
    endTime() {
      return moment.unix(this.end).format("HH:mm:ss");
    },
    volumeIcon() {
      if (this.volume <= 0.01) return "VolumeXIcon";
      if (this.volume >= 0.01 && this.volume <= 0.5) return "Volume1Icon";
      return "Volume2Icon";
    },
    fullscreenIcon() {
      if (!this.isFullscreen) return "MaximizeIcon";
      return "MinimizeIcon";
    },
    offsetCurrent() {
      return this.current - this.start;
    },

    player() {
      if (typeof this.$refs.hiddenVideoPlayer === "undefined") return null;
      return this.$refs.hiddenVideoPlayer.player;
    },
    playerOptions(){
      const cameraType = '4';
      let playerOption = JSON.parse(JSON.stringify(this.getPlayerOption(cameraType)));
      playerOption.controls = false;
      playerOption.autoplay = false;
      return playerOption;
    },

  },
  watch: {
    mode() {
      this.videoControlStyle.height = ( this.mode === 'history' ) ? '4rem' : '3.2rem';
    },
  },
  methods: {
    init() {
      this.volume = 0;
    },
    setFpsValue(val) {
      this.$emit("setFPS", val);
    },
    onPlay() {
      this.isPlay = !this.isPlay;
      this.$emit("onPlay", this.isPlay);
    },
    setPause() {
      this.isPlay = false;
    },
    onChangeVolume() {
      this.$emit("onChangeVolume", this.volume);
    },
    onPause() {
      this.$emit("onPause");
    },
    onChangeSeek(time) {
      this.$emit("onChangeSeek", Number(time));

      const el = this.$el.querySelector(".vue-slider-dot-tooltip-inner");
      let imgEl = this.$el.querySelector("img");
      if ( ! imgEl ) {
        imgEl = document.createElement("img");
        imgEl.style.width = '160px';
        imgEl.style.height = '90px';
        el.prepend(imgEl);
      }
      imgEl.src = this.thumbnails && this.thumbnails[ Math.floor( Number(time) / 300 ) ] ? this.thumbnails[ Math.floor( Number(time) / 300 ) ] : null;
      if ( !imgEl.src || !imgEl.src.startsWith('data:image/') || imgEl.src.length < 30 ) {
        imgEl.style.display = 'none';
      } else {
        imgEl.style.display = 'block';
      }

    },
    onChangeFullscreen() {
      this.isFullscreen = !this.isFullscreen;
      this.$emit("onChangeFullscreen", this.isFullscreen);
      this.videoControlStyle.left = 0;
      this.videoControlStyle.right = 0;
      this.videoControlStyle.bottom = 0;

    },
    setStyleToSmall() {
      this.isFullscreen = false;
      this.videoControlStyle.left = "";
      this.videoControlStyle.right = "";
      this.videoControlStyle.bottom = "";
    },

    kickCreateThumbnails(baseUrl) {
      this.thumbnails = [];
      const video = {
        withCredentials: false,
        type: "application/x-mpegurl",
        src: baseUrl
      };
      this.player.src(video);
      setTimeout(() => {
        // 動画がロードされてからサムネイルを順次キャプチャ。 @ready, @play 直後よりも遅くスタートさせる
        this.createThumbnails();
      }, 5000);
    },
    createThumbnails() {

      const video = this.$el.querySelector("video");
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      //  videoサイズと同じ canvas サイズを設定
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      this.player.currentTime(0);

      const captureIntervalMilliSeconds = 2000;
      for ( let i=0; i<=12; i++) {
        setTimeout(() => {
          if ( i === 12 ) {
            this.player.currentTime(0);
            this.player.off();
          } else {
            this.player.currentTime((i + 1) * 300 - 30);
            context.drawImage(video, 0, 0,  video.videoWidth, video.videoHeight);
            this.thumbnails.push(canvas.toDataURL('image/jpeg'));
          }
        }, i * captureIntervalMilliSeconds);
      }
    },

  },
  mounted() {
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.camera-player-controls {
  min-width: 100%;
  background-color: rgba(0,0,0,0.8);
  opacity: 1 !important;
  padding: 0.2rem 1rem;
}

.video-progress {
  position: relative;
  height: 8.4px;
  margin-bottom: 10px;
}

.play-back-video-seek-dot {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #2F80ED !important;
  border: 2px solid #2F80ED20;
  cursor: pointer;
}

progress {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 2px;
  width: 100%;
  height: 8.4px;
  pointer-events: none;
  position: absolute;
  top: 0;
}

progress::-webkit-progress-bar {
  background-color: #474545;
  border-radius: 2px;
}

progress::-webkit-progress-value {
  background-color: #474545;
  border-radius: 2px;
}

.bottom-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-controls {
  display: flex;
  align-items: center;
  color: #fff;
}

.right-controls {
  display: flex;
  align-items: center;
  color: #fff;
  margin-left: auto;
}

.volume-controls {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.volume-controls input {
  width: 100px;
  opacity: 1;
  transition: all 0.4s ease;
}

.volume-controls:hover input,
.volume-controls input:focus {
  width: 100px;
  opacity: 1;
}

.fullscreen-button {
  margin-right: 0;
}

input[type="range"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 8.4px;
  background: transparent;
  cursor: pointer;
}

input[type="range"]:focus {
  outline: none;
}

input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  cursor: pointer;
  border-radius: 1.3px;
  -webkit-appearance: none;
  transition: all 0.4s ease;
}

input[type="range"]::-webkit-slider-thumb {
  height: 16px;
  width: 16px;
  border-radius: 16px;
  background: #2F80ED;
  cursor: pointer;
  -webkit-appearance: none;
  margin-left: -1px;
}

input[type="range"]:focus::-webkit-slider-runnable-track {
  background: transparent;
}

input[type="range"].volume {
  height: 5px;
  background-color: #fff;
}

input[type="range"].volume::-webkit-slider-runnable-track {
  background-color: transparent;
}

input[type="range"].volume::-webkit-slider-thumb {
  margin-left: 0;
  height: 14px;
  width: 14px;
  background: #fff;
}

input[type="range"]::-moz-range-track {
  width: 100%;
  height: 8.4px;
  cursor: pointer;
  border: 1px solid transparent;
  background: transparent;
  border-radius: 1.3px;
}

input[type="range"]::-moz-range-thumb {
  height: 14px;
  width: 14px;
  border-radius: 50px;
  border: 1px solid #2F80ED;
  background: #2F80ED;
  cursor: pointer;
  margin-top: 5px;
}

input[type="range"]:focus::-moz-range-track {
  outline: none;
}

input[type="range"].volume::-moz-range-thumb {
  border: 1px solid #fff;
  background: #fff;
}

.play-button {
  svg {
    width: 24px;
    height: 24px;
    cursor: pointer;
    margin-right: 1rem;
  }
}

.pause-button {
  svg {
    width: 24px;
    height: 24px;
    cursor: pointer;
    margin-right: 1rem;
  }
}

.volume-button {
  svg {
    width: 24px;
    height: 24px;
    cursor: pointer;
    margin-right: 1rem;
  }
}


#playback-rate-menu {
  .vs-dropdown--menu, .vs-dropdown--menu--after {
    color: rgba(192, 192, 192, 0.8);
    background-color: rgba(0, 0, 0, 0.4);
  }
}

.playback-rate-item:hover {
  background-color: skyblue;
}

</style>
